import { useState } from "react";
const useInput = (defaultValue) => {
    const [value, setValue] = useState(defaultValue || '');
    const [error, setError] = useState('');
    return [value, setValue, error, setError];
};
export default useInput;
